import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "lg:grid lg:grid-cols-2 gap-[25px]",
  id: "clickToSeeCode"
}
const _hoisted_2 = { class: "lg:grid lg:grid-cols-3 gap-[25px]" }
const _hoisted_3 = { class: "lg:col-span-1" }
const _hoisted_4 = { class: "lg:col-span-2" }
const _hoisted_5 = { class: "lg:grid lg:grid-cols-3 gap-[25px]" }
const _hoisted_6 = { class: "lg:grid lg:grid-cols-5 gap-[25px]" }
const _hoisted_7 = { class: "lg:col-span-2" }
const _hoisted_8 = { class: "lg:col-span-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_TopSellingProducts = _resolveComponent("TopSellingProducts")!
  const _component_RecentOrders = _resolveComponent("RecentOrders")!
  const _component_TopPerformers = _resolveComponent("TopPerformers")!
  const _component_RecentLeads = _resolveComponent("RecentLeads")!
  const _component_AllProjects = _resolveComponent("AllProjects")!
  const _component_MyTasks = _resolveComponent("MyTasks")!
  const _component_StudentsProgress = _resolveComponent("StudentsProgress")!
  const _component_GroupLessons = _resolveComponent("GroupLessons")!
  const _component_PerformanceOfAgents = _resolveComponent("PerformanceOfAgents")!
  const _component_RecentCustomerRatings = _resolveComponent("RecentCustomerRatings")!
  const _component_ToDoList = _resolveComponent("ToDoList")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DataTable),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_TopSellingProducts),
      _createVNode(_component_RecentOrders)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_TopPerformers)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_RecentLeads)
      ])
    ]),
    _createVNode(_component_AllProjects),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_MyTasks),
      _createVNode(_component_StudentsProgress),
      _createVNode(_component_GroupLessons)
    ]),
    _createVNode(_component_PerformanceOfAgents),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_RecentCustomerRatings)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_ToDoList)
      ])
    ])
  ], 64))
}